import { render, staticRenderFns } from "./BasicsTab.vue?vue&type=template&id=3b16c2c0&scoped=true"
import script from "./BasicsTab.vue?vue&type=script&lang=js"
export * from "./BasicsTab.vue?vue&type=script&lang=js"
import style0 from "./BasicsTab.vue?vue&type=style&index=0&id=3b16c2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16c2c0",
  null
  
)

export default component.exports